var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "primary icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7067 2.39391L13.6067 3.29391C14.1333 3.81391 14.1333 4.66057 13.6067 5.18057L4.78667 14.0006H2V11.2139L8.93333 4.27391L10.82 2.39391C11.34 1.87391 12.1867 1.87391 12.7067 2.39391ZM3.33333 12.6672L4.27333 12.7072L10.82 6.15391L9.88 5.21391L3.33333 11.7606V12.6672Z",
    fill: "#3076FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ac83b6892ca9845ca964552e1bb09507.svg";
export { ForwardRef as ReactComponent };